import SharedSidebar from "../../shared/SharedSidebar";

const Sidebar = () => {
  return (
    <div>
      <div className="d-none d-lg-block">
        <SharedSidebar/>
      </div>
    </div>
  );
};

export default Sidebar;
